export type ChecklistVariant = "open" | "enclosed";

export type ChecklistVariantMeta = {
  id: ChecklistVariant;
  label: string;
  title: string;
  file: string;
  mobileFile: string;
  blurb: string;
  coverage: string;
};

export const CHECKLIST_VARIANTS: Record<ChecklistVariant, ChecklistVariantMeta> = {
  open: {
    id: "open",
    label: "Open transport",
    title: "Open Transport Quote Checklist",
    file: "/auto-transport-quote-checklist-open.pdf",
    mobileFile: "/auto-transport-quote-checklist-open-mobile.pdf",
    blurb:
      "Built for the standard 7–10 car open hauler: ground clearance limits, top-load vs bottom-load, weather exposure, and the questions that expose a lowball open quote.",
    coverage: "$250,000 cargo coverage on open carriers",
  },
  enclosed: {
    id: "enclosed",
    label: "Enclosed transport",
    title: "Enclosed Transport Quote Checklist",
    file: "/auto-transport-quote-checklist-enclosed.pdf",
    mobileFile: "/auto-transport-quote-checklist-enclosed-mobile.pdf",
    blurb:
      "Built for classic, exotic, luxury and low-clearance vehicles: liftgate vs ramp loading, soft-tie standards (never chains on the frame), declared value, and hard-side trailer requirements.",
    coverage: "$1,000,000 cargo coverage on enclosed carriers",
  },
};

/** Maps a Transport level form value to the matching checklist variant. */
export function variantFromTransportType(value: string | null | undefined): ChecklistVariant {
  return String(value ?? "")
    .toLowerCase()
    .includes("enclosed")
    ? "enclosed"
    : "open";
}
